export const personalInfo = {
  name: "Ludwig Sackey Narh",
  title: "Front-End Engineer",
  tagline: "I don't just write code.",
  tagline2: "I build things people love to use.",
  about:
    "Software Engineer with 7+ years of experience building production-grade web applications. I specialise in React and modern JavaScript with a sharp focus on clean architecture, usability and code that scales. I am the most driven engineer you will meet and I bring that energy to every line of code I write.",
  email: "thenarh17@gmail.com",
  phone: "+233 205845823",
  location: "Accra, Ghana",
  github: "https://github.com/TheNarh",
  linkedin: "https://www.linkedin.com/in/ludwig-sackey-narh-670078106/",
  cv: "https://drive.google.com/uc?export=download&id=1gJnfuSx40fubkUSDIXZlqlT8kRyuRB8N",
};

export const skills = [
  { name: "React.js", level: 90, category: "Frontend" },
  { name: "JavaScript", level: 92, category: "Frontend" },
  { name: "HTML5 / CSS3", level: 90, category: "Frontend" },
  { name: "useReducer", level: 85, category: "React" },
  { name: "useState", level: 95, category: "React" },
  { name: "useEffect", level: 88, category: "React" },
  { name: "REST APIs", level: 85, category: "Backend" },
  { name: "Git / GitHub", level: 88, category: "Tools" },
  { name: "Jest / RTL", level: 80, category: "Testing" },
  { name: "Responsive Design", level: 90, category: "Frontend" },
];

export const projects = [
  {
    id: 1,
    title: "The React Quiz App",
    description:
      "A timed quiz application that tests React knowledge — built with a finite state machine architecture, countdown timer, difficulty-weighted scoring, and live API integration.",
    tech: ["React", "useReducer", "useEffect", "JSON Server"],
    github: "https://github.com/TheNarh/The-React-Quiz",
    live: "https://ludwig-react-quiz.vercel.app/",
    highlights: [
      "Finite state machine with 8 action types",
      "Self-cleaning countdown timer with useEffect cleanup",
      "Difficulty-weighted scoring engine (10 / 20 / 30 pts)",
      "Full API lifecycle — loading, success, error states",
    ],
  },
  {
    id: 2,
    title: "Far Away: Packing Planner",
    description:
      "An interactive trip packing list app featuring real-time statistics, multi-criteria sorting, and clean lifted state architecture.",
    tech: ["React", "useState", "Controlled Components", "Derived State"],
    github: "https://github.com/TheNarh/React-Packing-Planner",
    live: "https://react-packing-planner.vercel.app/",
    highlights: [
      "Lifted state — single source of truth in App.jsx",
      "Three-criteria sorting with immutable .slice().sort()",
      "Live packing statistics via derived state",
      "Controlled form with guard clause validation",
    ],
  },
  {
    id: 3,
    title: "Fast React Pizza Co",
    description:
      "A React-based pizza menu app showcasing component composition, props, conditional rendering and clean UI logic.",
    tech: [
      "JavaScript ES6+",
      "JSX & Fragments",
      "List Rendering with .map()",
      "Conditional Rendering",
    ],
    github: "https://github.com/TheNarh/React-Pizza-Menu",
    live: "https://ludwig-pizza.vercel.app/",
    highlights: [
      "Engineered a data-driven restaurant menu application using React component composition and .map() rendering, driving the entire UI from a single data array so adding or removing items requires zero JSX changes.",
      "Implemented three distinct conditional rendering patterns in a single application, ternary operators, early returns and inline value switching: demonstrating a deliberate and context-aware approach to React UI logic.",
      "Built a real-time open/close system using live system clock logic inside a React component, rendering entirely different UI states based on current hour with no state management, no API calls, and no manual toggling.",
    ],
  },
];

export const experience = [
  {
    id: 1,
    role: "Software Engineer",
    company: "Verify Ghana",
    period: "January 2024 – Present",
    location: "Accra, Ghana",
    bullets: [
      "Own end-to-end architecture and delivery of secure, scalable applications in a production environment and driving reliability, performance and maintainability across the full codebase.",
      "Diagnose and resolve high-impact bugs in complex codebases alongside senior engineers, consistently delivering fixes that improve system uptime and user experience.",
      "Raise engineering standards across the team through rigorous code reviews, technical documentation and knowledge sharing to directly improve team output, quality and velocity.",
    ],
  },
  {
    id: 2,
    role: "Programmer",
    company: "Abuakwa South Municipal Assembly",
    period: "June 2018 – June 2023",
    location: "Kyebi, Ghana",
    bullets: [
      "Designed and shipped a data-driven revenue mobilisation platform that increased internally generated funds by 45%: a direct, quantifiable business outcome delivered through thoughtful system design and clean engineering.",
      "Led end-to-end digitisation of municipal services across the assembly, eliminating paper-based workflows, reducing manual errors and improving operational efficiency at scale.",
      "Managed the full software development lifecycle across multiple concurrent projects, from requirements through deployment, maintenance, and iteration with zero missed deadlines.",
    ],
  },
  {
    id: 3,
    role: "Leadership Intern",
    company: "Transforming Teaching Education and Learning(T-TEL)",
    period: "February 2017 – May 2017",
    location: "Accra, Ghana",
    bullets: [
      "Delivered 100% digitisation of workshop data, transforming inaccessible records into structured, traceable digital assets that measurably improved team decision-making.",
      "Authored data-driven technical reports consumed by senior leadership that demonstrated the ability to translate complex information into clear and actionable insight.",
    ],
  },
  {
    id: 4,
    role: "IT Support Assistant",
    company: "The West African Examinations Council, WAEC",
    period: "September 2015 – August 2016",
    location: "Accra, Ghana",
    bullets: [
      "Resolved complex technical issues with a 90% success rate, directly improving system reliability, uptime, and end-user satisfaction across the organisation.",
      "Reduced recurring escalations by training staff on structured troubleshooting best practices to build a more self-sufficient and technically capable workforce.",
    ],
  },
];
